import { findElementById, toggleVisibility } from '../Utils';

export function registerSiteHeader(): void {
    const SCROLL_UP_BREAKPOINT_RATIO = 0.05;
    const SCROLL_DOWN_BREAKPOINT_RATIO = 0.25;
    const SCROLLED_ATTR = 'data-scrolled';
    const $siteHeader = findElementById<HTMLDivElement>('siteHeader');
    const $siteHeaderMenuButton = findElementById<HTMLButtonElement>('siteHeaderMenuButton');
    const $siteHeaderMenu = findElementById<HTMLDivElement>('siteHeaderMenu');
    const $siteHeaderMenuOpen = findElementById('siteHeaderMenuOpen');
    const $siteHeaderMenuClose = findElementById('siteHeaderMenuClose');

    if ($siteHeader == null) {
        console.error('SiteHeader not found, not binding events!');
        return;
    }

    function onMenuClick() {
        const isVisible = toggleVisibility($siteHeaderMenu);

        if (isVisible != null) {
            document.body.classList.toggle('nav-open', isVisible);

            toggleVisibility($siteHeaderMenuOpen, !isVisible);
            toggleVisibility($siteHeaderMenuClose, isVisible);
        }
    }

    const onScroll = () => {
        const isAlreadyScrolled = $siteHeader.hasAttribute(SCROLLED_ATTR);
        let shouldAddScrollAttr: boolean;

        if (isAlreadyScrolled) {
            // If we scroll back wait until we see the header
            const headerOffset = $siteHeader.clientHeight * SCROLL_UP_BREAKPOINT_RATIO;
            shouldAddScrollAttr = !(window.scrollY < headerOffset);
        } else {
            // If we scroll down scroll until we get past the breakpoint
            const headerOffset = $siteHeader.clientHeight * SCROLL_DOWN_BREAKPOINT_RATIO;
            shouldAddScrollAttr = window.scrollY > headerOffset;
        }

        if (shouldAddScrollAttr != isAlreadyScrolled) {
            if (shouldAddScrollAttr) {
                $siteHeader.setAttribute(SCROLLED_ATTR, '');
            } else {
                $siteHeader.removeAttribute(SCROLLED_ATTR);
            }
        }
    };

    $siteHeaderMenuButton?.addEventListener('click', onMenuClick, false);

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
}
